/** @jsx jsx */
import { Menu, MenuItem } from '@blueprintjs/core';
import { jsx } from '@emotion/react';
import { WidgetControlsDispatchType } from 'views/common/WidgetControls/types';

export default function LegendRightClickMenu (
        {dispatch}:LegendRightClickMenuProps
    ) {
    return (
        <Menu>
            <MenuItem   onClick={()=>dispatch({type:"enableAllKeys"})}
                        text="Enable All"/>
            <MenuItem   onClick={()=>dispatch({type:"disableAllKeys"})}
                        text="Disable All"/>
        </Menu>
    )
}

interface LegendRightClickMenuProps {
    dispatch: WidgetControlsDispatchType
}

